import type { UpgradeDef } from './types';

/** One-time purchasable upgrades that apply permanent multipliers. */
export const UPGRADES: readonly UpgradeDef[] = [
  {
    id: 'gloves', name: 'Arbeitshandschuhe', icon: '🧤', cost: 200,
    description: 'Abbau ×2 pro Klick.',
    effect: { type: 'clickMult', value: 2 },
  },
  {
    id: 'reinforced', name: 'Verstärkte Stiele', icon: '🪛', cost: 2_500,
    description: 'Nochmal Abbau ×2 pro Klick.',
    effect: { type: 'clickMult', value: 2 },
    requires: { money: 1_000 },
  },
  {
    id: 'lubricant', name: 'Maschinenöl', icon: '🛢️', cost: 5_000,
    description: 'Auto-Abbau ×1,5.',
    effect: { type: 'autoMult', value: 1.5 },
    requires: { building: 'drill' },
  },
  {
    id: 'sharpdrills', name: 'Wolfram-Bohrköpfe', icon: '🔩', cost: 35_000,
    description: 'Auto-Abbau ×2.',
    effect: { type: 'autoMult', value: 2 },
    requires: { lifetimeEarnings: 4e4 },
  },
  {
    id: 'broker', name: 'Erz-Makler', icon: '🤝', cost: 60_000,
    description: 'Alles, was du verkaufst, ist ×1,5 wert.',
    effect: { type: 'valueMult', value: 1.5 },
    requires: { lifetimeEarnings: 8e4 },
  },
  {
    id: 'turbine', name: 'Turbinen-Tuning', icon: '🌬️', cost: 120_000,
    description: 'Kraftwerke erzeugen ×1,5 Energie.',
    effect: { type: 'energyMult', value: 1.5 },
    requires: { building: 'powerplant' },
  },
  {
    id: 'unions', name: 'Bergarbeiter-Gewerkschaft', icon: '📋', cost: 5e5,
    description: 'Arbeiter bauen ×2 ab.',
    effect: { type: 'workerMult', value: 2 },
    requires: { lifetimeEarnings: 6e5 },
  },
  {
    id: 'flux', name: 'Schmelzfluss', icon: '⚗️', cost: 8e5,
    description: 'Schmelzöfen verarbeiten ×2 schneller.',
    effect: { type: 'smeltMult', value: 2 },
    requires: { building: 'smelter' },
  },
  {
    id: 'logistics', name: 'Globale Logistik', icon: '🌐', cost: 1e7,
    description: 'Alles ×1,5 (global).',
    effect: { type: 'globalMult', value: 1.5 },
    requires: { lifetimeEarnings: 1.2e7 },
  },
  {
    id: 'ai', name: 'Betriebs-KI', icon: '🧠', cost: 2.5e8,
    description: 'Alles ×2 (global).',
    effect: { type: 'globalMult', value: 2 },
    requires: { lifetimeEarnings: 3e8, tech: 'ai' },
  },
  {
    id: 'exosuits', name: 'Arbeiter-Exoskelette', icon: '🦾', cost: 4e9,
    description: 'Arbeiter bauen ×3 ab.',
    effect: { type: 'workerMult', value: 3 },
    requires: { lifetimeEarnings: 5e9 },
  },
  {
    id: 'reactor', name: 'Fusionsreaktor', icon: '🔆', cost: 6e10,
    description: 'Kraftwerke erzeugen ×2 Energie.',
    effect: { type: 'energyMult', value: 2 },
    requires: { lifetimeEarnings: 8e10, tech: 'antimatter' },
  },
  {
    id: 'overlord', name: 'KI-Overlord', icon: '👁️', cost: 1e12,
    description: 'Alles ×3 (global).',
    effect: { type: 'globalMult', value: 3 },
    requires: { lifetimeEarnings: 1.5e12, tech: 'antimatter' },
  },
] as const;

export const UPGRADE_BY_ID: Record<string, UpgradeDef> = Object.fromEntries(
  UPGRADES.map((u) => [u.id, u]),
);
